"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { AnimatePresence, motion } from "framer-motion";
import { useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import WaveDelete from "./delete/WaveDelete";
import WaveMute from "./mute/WaveMute";
export default function WaveHeaderOptions(t0) {
  const $ = _c(16);
  const {
    wave
  } = t0;
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const listRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOptionsOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useClickAway(listRef, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOptionsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useKeyPressEvent("Escape", t2);
  let t3;
  if ($[2] !== isOptionsOpen) {
    t3 = e => {
      e.stopPropagation();
      setIsOptionsOpen(!isOptionsOpen);
    };
    $[2] = isOptionsOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-sr-only">Open options</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="tw-size-5 tw-flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3) {
    t6 = <button type="button" className="tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-size-8 tw-border-0 tw-text-iron-300 hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300 desktop-hover:hover:tw-ring-1 desktop-hover:hover:tw-ring-iron-700 desktop-hover:hover:tw-ring-inset tw-transition tw-duration-300 tw-ease-out" id="options-menu-0-button" aria-expanded="false" aria-haspopup="true" onClick={t3}>{t4}{t5}</button>;
    $[6] = t3;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isOptionsOpen || $[9] !== wave) {
    t7 = isOptionsOpen && <motion.div className="tw-absolute tw-right-0 tw-z-10 tw-mt-2 tw-w-40 tw-origin-top-right tw-rounded-lg tw-bg-iron-900 tw-py-2 tw-shadow-lg tw-ring-1 tw-ring-white/10 tw-focus:tw-outline-none" role="menu" aria-orientation="vertical" aria-labelledby="options-menu-0-button" tabIndex={-1} initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div><WaveMute wave={wave} onSuccess={() => setIsOptionsOpen(false)} /><WaveDelete wave={wave} /></div></motion.div>;
    $[8] = isOptionsOpen;
    $[9] = wave;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <AnimatePresence mode="wait" initial={false}>{t7}</AnimatePresence>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="tw-relative tw-z-20" ref={listRef}>{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}